export default __webpack_public_path__ + "images/ca1172442730b5443715b2ebded8a8c8.gif";